import { GuaranteeForm } from "@app/guaranteeForm";
import { useAccurateContext } from "@utils/useAccurateContext";
import { createContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useGetGuaranteeInfo } from "./useGetGuaranteeInfo";
import { useOrderFormContext } from "@app/orderInfo";
import { Button, message } from "antd";
import { useSaveOrder } from "./useSaveOrder";

type GuaranteeWrapperProps = {
  prefix: string;
  config: {
    title: string;
    readonly: boolean;
    canEditPurchase?: boolean;
  } & Partial<Record<string, unknown>>;
};

interface GuaranteeFormContextI {
  formDisabled: boolean;
  prefix: string;
  isStartForm: boolean;
  canEditPurchase: boolean;
}

export const GuaranteeFormContext = createContext<GuaranteeFormContextI | null>(null);
export const useBgFormContext = () => useAccurateContext(GuaranteeFormContext);

export const GuaranteeFormWrapper = ({ config, prefix }: GuaranteeWrapperProps) => {
  const { model } = useOrderFormContext();
  const id = model?.components?.productBgCard?.id || "";
  const { bgData } = useGetGuaranteeInfo(id);
  const methods = useForm();
  const { handleSave, saving } = useSaveOrder(id, methods.handleSubmit);

  useEffect(() => {
      if (bgData) {
        methods.reset({
          productBg: {
            guarantee: bgData.components.productBg.guarantee,
            purchase: bgData.components.productBg.purchase
          }
        });
      }
    }, [bgData]);

  const onSave = async () => {
    try {
      const newModel = await handleSave();
      message.success("Форма гарантии сохранена");
      methods.reset(newModel.components);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <FormProvider {...methods}>
      <GuaranteeFormContext.Provider
        value={{
          formDisabled: config.readonly,
          prefix,
          isStartForm: false,
          canEditPurchase: config.canEditPurchase ?? true,
        }}
      >
        <fieldset disabled={config.readonly}>
          <GuaranteeForm />
        </fieldset>
        <Button type="primary" onClick={onSave} loading={saving} disabled={saving}>Сохранить</Button>
      </GuaranteeFormContext.Provider>
    </FormProvider>
  );
};
